module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00044.60139009.jpg";